import { tokens } from "@core/theme/tokens";

// Medidas de layout extraídas de admin.jsx (SegUsuarios, :3488) — igual
// criterio que catalogStyles.ts: DESIGN-TOKENS.md no define escala de
// espaciado/tamaño, así que estos números viven acá.
export const userStyles = {
  toolbar: {
    padding: 14,
    gap: 12,
    marginBottom: 16,
    searchWidth: 260,
  },
  header: {
    marginBottom: 22,
    titleFontSize: 28,
    subtitleMargin: "6px 0 0",
    subtitleFontSize: 13,
  },
  table: {
    // Nombre · Usuario · Correo · Perfil · Lugar asociado · Último acceso ·
    // Estado (SPEC-215 §2), acciones al final vía rowActions de CursorTable.
    gridTemplateColumns: "1.4fr 1fr 1.5fr 1.1fr 1.3fr 1.1fr 100px",
    actionsGap: 6,
  },
  badge: { padding: "6px 11px", fontSize: 11 },
  scrim: "rgba(0,0,0,0.5)",
  modal: { padding: 24, maxHeight: "82vh", width: 640 },
  panel: {
    background: tokens.surface.bg2,
    border: `1px solid ${tokens.surface.line}`,
    borderRadius: tokens.radius.lg,
    boxShadow: tokens.shadow,
  },
  form: { inputPadding: "9px 10px", fieldGap: 5, gridGap: "0 16px" },
  warning: { padding: "10px 12px", marginTop: 4, marginBottom: 4 },
} as const;
